import { render, staticRenderFns } from "./BusyNotary.vue?vue&type=template&id=d3d189ec&"
import script from "./BusyNotary.vue?vue&type=script&lang=ts&"
export * from "./BusyNotary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports